import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';

export const columnsItems = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'iban',
    label: 'External account',
    hidden: false,
    sortable: false,
  },
  {
    name: 'currencyId',
    label: 'Currency',
    hidden: false,
    sortable: false,
  },
  {
    name: 'caspId',
    label: 'CASP',
    hidden: false,
    sortable: false,
  },
  {
    name: 'paymentType',
    label: 'Payment type',
    hidden: false,
    sortable: false,
  },
  {
    name: 'accountId',
    label: 'Account',
    hidden: false,
    sortable: false,
  },
  {
    name: 'accountType',
    label: 'Customer type',
    hidden: false,
    sortable: false,
  },
  {
    name: 'createdAt',
    label: 'Created Date',
    hidden: false,
    sortable: false,
  },
  {
    name: 'active',
    label: 'Status',
    hidden: false,
    sortable: false,
    filterModalPlacement: 'right',
  },
  {
    name: 'createType',
    label: 'Create Type',
    hidden: false,
    sortable: false,
    filterModalPlacement: 'right',
  },
];

export const columnsLabels = {
  iban: 'External Account',
  active: 'Status',
  accountId: 'Account',
  createType: 'Create Type',
};

export const defaultSorter = {};

export const schema = {
  iban: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  active: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  accountId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  createType: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [
  {
    name: 'iban',
    type: FilterType.TEXT,
    placeholder: 'Enter IBAN...',
  },
  {
    name: 'accountId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Select account',
  },
  {
    name: 'active',
    type: FilterType.RADIO,
    fields: [
      {
        name: 'active',
        title: 'All',
        value: 'ALL',
      },
      {
        name: 'active',
        title: 'Enabled',
        value: 'ENABLED',
      },
      {
        name: 'active',
        title: 'Disabled',
        value: 'DISABLED',
      },
    ],
  },
  {
    name: 'createType',
    type: FilterType.RADIO,
    fields: [
      {
        name: 'createType',
        title: 'Auto',
        value: 'AUTO',
      },
      {
        name: 'createType',
        title: 'Manual',
        value: 'MANUAL',
      },
    ],
  },
];
